import { CollectionStatisticPeriod } from "@anaconda/core/nft-collection/search/types"
import { Trans } from "@lingui/macro"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import type { AvailableStatisticPeriod } from "../../default-values"
import { CollectionLeaderboardFiltersMoleculeReatom } from "../../store.reatom"

const LABEL_BY_PERIODL: Record<AvailableStatisticPeriod, React.ReactNode> = {
  [CollectionStatisticPeriod.H1]: <Trans>1h</Trans>,
  [CollectionStatisticPeriod.H6]: <Trans>6h</Trans>,
  [CollectionStatisticPeriod.DAY]: <Trans>24h</Trans>,
  [CollectionStatisticPeriod.WEEK]: <Trans>7d</Trans>,
  [CollectionStatisticPeriod.MONTH]: <Trans>30d</Trans>,
}

export const gePeriodLabel = (period: AvailableStatisticPeriod) =>
  LABEL_BY_PERIODL[period]

export const useStatisticPeriod = () => {
  const { statisticPeriod } = useMolecule(
    CollectionLeaderboardFiltersMoleculeReatom,
  )
  return statisticPeriod()
}

export const useStatisticPeriodLabel = () => {
  const statisticPeriod = useStatisticPeriod()

  return gePeriodLabel(statisticPeriod)
}
